import React, {useContext, useState} from 'react';
import {observer} from 'mobx-react-lite';
import {
    Button,
    Grid,
    GridColumn,
    Modal,
    ModalCloser,
    ModalContent,
    ModalFooter,
    ModalHeader,
    TextField,
} from '../../../patterns';
import {StoreContext} from '../base/root-store';

export const EditTargetsModal = observer((): JSX.Element => {
    const store = useContext(StoreContext).companyStore;
    const initialSettings = store.payload!.target;

    const [activityRate, setActivityRate] = useState<string>(initialSettings ? initialSettings.activityRate : '');
    const [resultRate, setResultRate] = useState<string>(initialSettings ? initialSettings.resultRate : '');

    const handleInputChange = (setter: React.Dispatch<React.SetStateAction<string>>, value: string) => {
        const sanitizedValue = value.replace(/[^\d]/g, '').trim();

        if (sanitizedValue !== '') {
            const numberValue = parseInt(sanitizedValue, 10);

            if (!isNaN(numberValue) && numberValue >= 0 && numberValue <= 100) {
                setter(`${numberValue}`);
            }
        } else {
            setter('');
        }
    };
    const isSaveEnabled = () => {
        const activityRateFilled = activityRate !== '';
        const resultRateFilled = resultRate !== '';

        return (activityRateFilled && resultRateFilled) || (!activityRateFilled && !resultRateFilled);
    };

    return (
        <Modal size="small">
            <ModalHeader>
                <h4>{store.label('company.actions.target-settings')}</h4>
            </ModalHeader>
            <ModalContent>
                <div className="text">
                    <div className="input-wrapper">
                        <TextField
                            label={store.label('company.actions.target-activity')}
                            value={`${activityRate}%`}
                            onChange={(value): void => handleInputChange(setActivityRate, value)}
                            id='target-modal.activity'
                            name='target-modal.activity'
                        />
                    </div>
                    <div className="input-wrapper">
                        <TextField
                            label={store.label('company.actions.target-result')}
                            value={`${resultRate}%`}
                            onChange={(value): void => handleInputChange(setResultRate, value)}
                            id='target-modal.result'
                            name='target-modal.result'
                        />
                    </div>
                </div>
            </ModalContent>
            <ModalFooter>
                <Grid wrap={['xs']} justify={['between-xs']}>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <ModalCloser>
                            <Button block={true} color="white" text={store.label('company.modal.cancel')}/>
                        </ModalCloser>
                    </GridColumn>
                    <GridColumn width={['xs-12', 'sm-6']}>
                        <Button
                            block={true}
                            text={store.label('company.modal.save')}
                            onClick={(): void => store.saveCompanyTargets({ activityRate, resultRate })}
                            disabled={!isSaveEnabled()}
                        />
                    </GridColumn>
                </Grid>
            </ModalFooter>
        </Modal>
    );
});
